// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';
import InboxErrorRenderer from './InboxErrorRenderer';

const getErrorMessage = (error) => `Error rendering inbox: ${error.toString()}`;

const getRollbarErrorDetails = (error, info, props) => ({
    boardId: props.currentBoardId,
    stack: info.componentStack,
});

const InboxErrorBoundary = (props) => (
    <ErrorBoundary
        {...props}
        ErrorRenderer={InboxErrorRenderer}
        getErrorMessage={getErrorMessage}
        getRollbarErrorDetails={getRollbarErrorDetails}
    />
);

InboxErrorBoundary.propTypes = {
    currentBoardId: PropTypes.string,
};

export default InboxErrorBoundary;
